import PreviewLayout from "./preview-layout";
import type { FlowSection } from "../form-builder/types";
import type { BrandKit } from "@/modules/brand/types";

interface PreviewConsentProps {
	id: string;
	section: FlowSection;
	brandName: string;
	brandLogo: string | null;
	brandkit: BrandKit;
	isSelected: boolean;
	onTitleChange: (title: string) => void;
	onDescriptionChange: (description: string) => void;
	isDarkMode?: boolean;
}

export default function PreviewConsent({ id, section, brandName, brandLogo, brandkit, isSelected, onTitleChange, onDescriptionChange, isDarkMode = false }: PreviewConsentProps) {
	void isSelected;

	return (
		<PreviewLayout
			id={id}
			brandName={brandName}
			brandLogo={brandLogo}
			brandkit={brandkit}
			title={section.title}
			titlePlaceholder="Share your testimonial?"
			subtitle={section.description}
			subtitlePlaceholder="Add a description..."
			showBackButton
			progress={{ current: 5, total: 6 }}
			continueLabel="Submit"
			editableTitle
			editableSubtitle
			onLocalTitleChange={onTitleChange}
			onLocalSubtitleChange={onDescriptionChange}
			isDarkMode={isDarkMode}
		>
			<div className="space-y-3">
				{/* Public option - matching step-consent styling */}
				<div className={`w-full p-5 rounded-xl border text-left shadow-sm cursor-not-allowed ${isDarkMode ? "border-gray-800 bg-gray-950" : "border-gray-100 bg-white"}`}>
					<div className="flex items-center gap-4">
						<div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>{/* Empty radio */}</div>
						<div>
							<p className={`font-medium ${isDarkMode ? "text-white" : "text-primary"}`} style={{ fontFamily: "var(--font-body, inherit)" }}>
								Share it publicly
							</p>
							<p className={`text-sm mt-0.5 ${isDarkMode ? "text-gray-400" : "text-secondary"}`} style={{ fontFamily: "var(--font-body, inherit)" }}>
								On your website, social media, and marketing materials
							</p>
						</div>
					</div>
				</div>

				{/* Anonymous option - matching step-consent styling */}
				<div className={`w-full p-5 rounded-xl border text-left shadow-sm cursor-not-allowed ${isDarkMode ? "border-gray-800 bg-gray-950" : "border-gray-100 bg-white"}`}>
					<div className="flex items-center gap-4">
						<div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>{/* Empty radio */}</div>
						<div>
							<p className={`font-medium ${isDarkMode ? "text-white" : "text-primary"}`} style={{ fontFamily: "var(--font-body, inherit)" }}>
								Share it anonymously
							</p>
							<p className={`text-sm mt-0.5 ${isDarkMode ? "text-gray-400" : "text-secondary"}`} style={{ fontFamily: "var(--font-body, inherit)" }}>
								On your website, social media, and marketing materials
							</p>
						</div>
					</div>
				</div>

				{/* Private option */}
				<div className={`w-full p-5 rounded-xl border text-left shadow-sm cursor-not-allowed ${isDarkMode ? "border-gray-800 bg-gray-950" : "border-gray-100 bg-white"}`}>
					<div className="flex items-center gap-4">
						<div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>{/* Empty radio */}</div>
						<div>
							<p className={`font-medium ${isDarkMode ? "text-white" : "text-primary"}`} style={{ fontFamily: "var(--font-body, inherit)" }}>
								Keep it private
							</p>
							<p className={`text-sm mt-0.5 ${isDarkMode ? "text-gray-400" : "text-secondary"}`} style={{ fontFamily: "var(--font-body, inherit)" }}>
								For internal use and feedback only
							</p>
						</div>
					</div>
				</div>
			</div>
		</PreviewLayout>
	);
}
